import * as React from "react"
import { AfterPage } from "types/afterjs"
import { Col, Row } from "reactstrap"
import { TypedJs, Typography, Paper, Seo } from "components"
import CountTo from "react-count-to"
import { toPersianDigits } from "utils"

interface About {
	//
}

const strings = [
	"با ما همراه باشید در موفقیت.",
	"با ما همراه باشید در توسعه.",
	"با ما همراه باشید در موفقیت.",
]

const fn = (value: string | number) => <span>{toPersianDigits(value)}</span>

const About: AfterPage<About> = () => {
	return (
		<>
			<Seo
				title="درباره ما"
				description="مرجع آنتی ویروس ایران متعلق به شرکت فناوری اطلاعات نیماک (سهامی خاص) به شمار ثبت ۲۳۲۷۴۹ و تاسیس ۱۳۸۳ می‌باشد."
				path="/about-us"
			/>
			<Row>
				<Col lg={12}>
					<Paper className="p-2">
						<Typography gutterBottom variant="h5">
							<TypedJs
								strings={strings}
								className="text-center py-1 font-weight-bold"
							/>
						</Typography>
						<Typography gutterBottom variant="body1">
							مرجع آنتی ویروس ایران یکی از خانواده های گروه فناوری
							اطلاعات نیماک می باشد ، که در سال ۱۳۸۳ با هدف ارائه
							راهکار ها و محصولات امنیتی برای ارگان ها ، مشاغل
							کوچک و بزرگ و کاربران خانگی تأسیس شد . سایت آنتی
							ویروس ایران با برسی تخصصی آنتی ویروس ها و نرم
							افزارهای امنیتی و برسی تهدیدات سایبری و ارائه اخبار
							و مقالات مرتبط سعی بر آگاهی هرچه بیشتر مشتریان و
							کاربران از خطرات احتمالی را دارد . رسالت گروه فناوری
							اطلاعات نیماک عرضه محصولات اورجینال و آگاهی رسانی به
							کاربران از خطرات محصولات تقلبی و جلوگیری از نقض حریم
							خصوصی کاربران در برابر مجرمان و سودجویان اینترنتی می
							باشد .
						</Typography>
						<div className="d-flex flex-md-row flex-column align-items-center justify-content-around py-5 my-4 mx-n2 background-accent bg-primary text-white">
							<div>
								<Typography
									gutterBottom
									variant="h5"
									align="center"
									weight="bold"
								>
									<CountTo to={27} speed={2500}>
										{fn}
									</CountTo>
									+
								</Typography>
								<Typography
									className="mb-4"
									weight="bold"
									variant="h5"
								>
									سال فعالیت
								</Typography>
							</div>
							<div>
								<Typography
									gutterBottom
									variant="h5"
									align="center"
									weight="bold"
								>
									<CountTo to={411} speed={2500}>
										{fn}
									</CountTo>
									+
								</Typography>
								<Typography
									className="mb-4"
									weight="bold"
									variant="h5"
								>
									مشتریان دولتی
								</Typography>
							</div>
							<div>
								<Typography
									gutterBottom
									variant="h5"
									align="center"
									weight="bold"
								>
									<CountTo to={8423} speed={2500}>
										{fn}
									</CountTo>
									+
								</Typography>
								<Typography
									className="mb-4"
									variant="h5"
									weight="bold"
								>
									مشتریان غیر دولتی
								</Typography>
							</div>
							<div>
								<Typography
									gutterBottom
									variant="h5"
									align="center"
									weight="bold"
								>
									<CountTo to={824527} speed={2500}>
										{fn}
									</CountTo>
									+
								</Typography>
								<Typography variant="h5" weight="bold">
									فروش آنتی ویروس
								</Typography>
							</div>
						</div>
						<Typography gutterBottom component="h1" variant="h5">
							درباره{" "}
							<span className="font-weight-bold">
								مرجع آنتی ویروس ایران
							</span>
						</Typography>
						<div className="d-flex flex-lg-row flex-column">
							<Typography
								gutterBottom
								variant="body2"
								className="flex-even"
							>
								مرجع آنتی ویروس ایران فعالیت خود را در سال ۱۳۶۹
								در فروشگاهی کوچک در خیابان جمهوری و با عرضه نرم
								افزار برای کامپیوترهای اسپکتروم، کمودور ۶۴،
								آمیگا ۵۰۰ و کامپیوترهای شخصی ۸۰۸۶ آغاز و تا کنون
								به فعالیت خود حول محور انفورماتیک ادامه داده
								است. از افتخارات ما عرضه آنتی ویروس در سال ۱۳۷۳
								برای مقابله به ویروس کامپیوتری OneHalf می‌باشد.
							</Typography>
							<Typography
								gutterBottom
								variant="body2"
								className="mx-md-2 flex-even"
							>
								مرجع آنتی ویروس ایران با اطلاع رسانی اخبار مهم و
								فعالیت‌های جدید صورت گرفته در حوزه ضد ویروس به
								کاربران کمک می‌کند تا با امنیت بیشتری از دستگاه
								خود استفاده نمایند.
							</Typography>
							<Typography
								gutterBottom
								variant="body2"
								className="flex-even"
							>
								روزانه بر تعداد ویروس‌ها و کدهای مخربی که قابلیت
								اجرا و ‫انتقال خودکار دارند، افزوده می‌شود. این
								ویروس‌ها از طریق ‫انواع حافظه‌های جانبی منتقل
								می‌شوند.
							</Typography>
						</div>
					</Paper>
				</Col>
			</Row>
		</>
	)
}

export default About
